// Shared helper for category lists returned by the various `categories_all` endpoints
// (each row has `id`, `item_count` — direct matches only — and `parent`).
// A parent category's own `item_count` only reflects items assigned to it directly, so a
// purely organizational parent with no items of its own (only via subcategories) reads as
// empty unless we roll subcategory counts up into it.
export function buildCategoryDisplayCounts(categories) {
  const categoryMap = new Map(categories.map((c) => [c.id, c]));
  const childrenByParent = new Map();
  categories.forEach((c) => {
    if (c.parent == null) return;
    if (!childrenByParent.has(c.parent)) childrenByParent.set(c.parent, []);
    childrenByParent.get(c.parent).push(c.id);
  });

  const cache = new Map();
  const resolve = (id, visited) => {
    if (cache.has(id)) return cache.get(id);
    if (visited.has(id)) return 0; // guard against a cyclical parent chain
    visited.add(id);
    const own = categoryMap.get(id)?.item_count || 0;
    const childTotal = (childrenByParent.get(id) || []).reduce((sum, childId) => sum + resolve(childId, visited), 0);
    const total = own + childTotal;
    cache.set(id, total);
    return total;
  };

  categories.forEach((c) => resolve(c.id, new Set()));
  return cache;
}
